<svelte:options accessors />

<script lang="ts">
  import type { EventDispatcher } from "svelte";
  import { BUTTON_ID } from "../..";

  export let price: number | null;
  export let header: string | null;
  export let text: string | null;
  export let totalFootprint: number | null;
  export let inCart: boolean | null;
  export let dispatch: EventDispatcher<any>;
  export let modalCallback: () => void;
</script>

{#if price && price !== 0}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div id={BUTTON_ID}>
    <div class="pina-button-header" on:click={modalCallback}>
      {header}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    </div>
    <div class="pina-button">
      <input
        type="checkbox"
        class="pina-button-input"
        bind:checked={inCart}
        on:change={() => dispatch("toggleOffset", { active: inCart })}
      />

      <div class="pina-button-body">
        <div class="pina-button-headline">
          {price.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} € für {totalFootprint &&
            totalFootprint.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} kg CO₂
        </div>
        <div class="pina-button-title">{text}</div>
      </div>
      <img
        alt="pina-logo"
        class="pina-button-logo"
        src="https://static.climate-app.pina.earth/assets/Logo_PINA_EARTH.svg"
      />
    </div>
  </div>
{/if}

<style>

.pina-button-header {
  font-weight: 700;
}

.pina-button-header:hover {
  text-decoration: underline;
  cursor: pointer;
}

.pina-button-header svg {
  margin-left: 0.2rem;
}

.pina-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  position: relative;
  padding: 0.8rem;
  margin-top: 0.5rem;
  border: 3px solid #ccc;
  border-radius: 0.5rem;
  background-color: #fff;
  font-weight: 700;

  &:has(input:checked) {
    border-color: #7daf6b;
  }
}

.pina-button.active {
  border-color: #7daf6b;
}

.pina-button-headline {
  font-size: 0.8rem;
  line-height: 1;
  margin-bottom: 0.3rem;
}

.pina-button-title {
  font-size: 1rem;
  line-height: 1;
}

.pina-button-logo {
  width: 2.5rem;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

input.pina-button-input[type="checkbox"] {
  width: 22px;
  height: 22px;
  position: relative;
  border: 2px solid #ccc !important;
  border-radius: 4px;
  appearance: none;
  outline: 0;
  cursor: pointer;
  transition: background 175ms cubic-bezier(0.1, 0.1, 0.25, 1);
}

input.pina-button-input[type="checkbox"]::before {
  position: absolute;
  content: "";
  display: block;
  top: 0;
  left: 5px;
  width: 8px;
  height: 14px;
  border-style: solid;
  border-color: #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 1;
}

input.pina-button-input[type="checkbox"]:checked {
  color: #fff !important;
  border-color: #7daf6b !important;
  background: #7daf6b !important;
}

input.pina-button-input[type="checkbox"]:checked::before {
  opacity: 1;
}

input.pina-button-input[type="checkbox"]:hover {
  cursor: pointer;
}

</style>
